import React, {useMemo, useState, useEffect} from "react";
import ReactJson from "react-json-view";
import {DragDropContext, Droppable, Draggable} from "react-beautiful-dnd";
import {cloneDeep, isEmpty} from "lodash";
import {Input, Checkbox} from "antd";
import {MenuOutlined} from "@ant-design/icons";
import {language} from "@/utils/language";

const grid = 8;

const getItemStyle = (isDragging, draggableStyle, disable) => {
        const s = {
            // some basic styles to make the items look a bit nicer
            userSelect: "none",
            padding: grid,
            margin: `0 0 ${grid}px 0`,
            display: "flex",
            alignItems: "center",
            wordBreak: "break-all",
            wordWrap: "break-word",
            background: isDragging ? "lightsteelblue" : "aliceblue",
            ...draggableStyle,
        }
        if (disable) {
            s.cursor = "not-allowed";
            s.filter = "grayscale(60%)";
        }
        return s
    }
;

const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? "lightblue" : "white",
    padding: grid,
    minHeight: "6em",
    width: "100%",
});

export default function Index({info, answer, changeAnswer}) {
    let {childs, options} = info;
    childs = useMemo(
        () => childs.filter((o) => !o.hide && !o.moduleOption),
        [childs]
    );
    options = useMemo(
        () => options
            .filter((o) => !o.hide && !o.moduleOption)
            .filter((o) => !(o?.selected !== 1 && o?.hide === 1))
        ,
        [options]
    );

    const [leftOptions, setLeftOptions] = useState(options);
    const [answerObj, setAnswerObj] = useState({});

    let fixedOne = null;
    if (options.find(o => o?.fixed === 1 && o?.selected === 1 && o?.hideSelected !== 1)) {
        fixedOne = {
            id: "-1",
            description: (info?.childDescriptions?.[0]) || "",
            selectedOption: options.find(o => o?.fixed === 1 && o?.selected === 1),
            moduleOption: 1,
            fixedOne: true
        };
    }

    const onChange = (e, id) => {
        const value = e.target.value;
        const optId = Object.keys(answer[info.id][id])[0];
        answer[info.id][id][optId] = value;
        changeAnswer(answer[info.id]);
    };

    useEffect(() => {
        const find = options.find(o => o?.fixed !== 1 && o?.selected === 1)
        if (find) {
            const findc = childs.find(c => c?.options?.find(o => o?.id === find?.id))
            if (findc) {
                const newA = {}
                newA[findc.id] = {[find.id]: null};
                changeAnswer(newA)
            }
        }
    }, []);

    useEffect(() => {
        if (isEmpty(answerObj)) return;
        const newAnswers = {};
        for (const [qustionId, option] of Object.entries(answerObj)) {
            const {codeValue} = option;
            const qustion = childs.find((q) => q.id === qustionId);
            const realOpt = qustion.options.find((o) => o.codeValue === codeValue);
            const optionId = realOpt.id;
            const defaultStr = answer?.[info.id]?.[qustionId]?.[optionId];
            newAnswers[qustionId] = {[optionId]: defaultStr || null};
        }
        changeAnswer(newAnswers);
    }, [answerObj]);

    function id2Code(id) {
        let code = "";
        childs.map(({options}) => {
            options.map((option) => {
                if (option.id === id && code === "") {
                    code = option.codeValue;
                }
            });
        });
        return code;
    }

    useEffect(() => {
        if (isEmpty(answerObj)) {
            try {
                const ansObj = answer[info.id];
                const obj = {};
                let left = cloneDeep(leftOptions);
                for (const [id, opt] of Object.entries(ansObj)) {
                    const optId = Object.keys(opt)[0];
                    for (let i = 0; i < childs.length; i++) {
                        const child = childs[i];
                        const {options} = child;
                        for (let j = 0; j < options.length; j++) {
                            const option = options[j];
                            if (option.id === optId) {
                                obj[id] = option;
                                const code = id2Code(optId);
                                console.log(code);
                                left = left.filter(({codeValue}) => codeValue !== code);
                            }
                        }
                    }
                }
                setAnswerObj(obj);
                setLeftOptions(left);
            } catch (error) {
            }
        }
    }, [answer]);


    const questions = childs.map((q) => {
        // 当前题的答案
        const item = answerObj[q.id];
        let defaultValue;
        try {
            const optId = Object.keys(answer[info.id][q.id])[0];
            defaultValue = answer[info.id][q.id][optId]["text"];
            // console.log(defaultValue);
        } catch (error) {
        }
        return (
            <div
                key={q.id}
                style={{
                    background: "#bbd7f9",
                    margin: 10,
                    padding: 1,
                }}
            >
                <Droppable droppableId={q.id}>
                    {(provided, snapshot) => (
                        <>
                            <div
                                style={{margin: 2, marginLeft: 10}}
                                dangerouslySetInnerHTML={{
                                    __html: q.description,
                                }}
                            />
                            <div
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}
                            >
                                {!!item && (
                                    <Draggable
                                        key={item.id}
                                        draggableId={item.codeValue + ""}
                                        index={0}
                                    >
                                        {(provided, snapshot) => (
                                            <>
                                                <div
                                                    className="draggable"
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}
                                                >
                                                    <Checkbox
                                                        style={{marginRight: 10, verticalAlign: "middle"}}
                                                        defaultChecked={true}
                                                        onChange={({target: {checked}}) => {
                                                            handleCheckbox(item, checked);
                                                        }}
                                                    />
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: item.description,
                                                        }}
                                                    />
                                                    <MenuOutlined
                                                        style={{
                                                            transform: "scaleX(1.5)",
                                                            color: "gray",
                                                            marginLeft: "auto",
                                                        }}
                                                    />
                                                </div>
                                                {!!item.open && (
                                                    <Input
                                                        placeholder={language().input_placeholder}
                                                        defaultValue={defaultValue}
                                                        onChange={(e) => onChange(e, q.id)}
                                                    />
                                                )}
                                            </>
                                        )}
                                    </Draggable>
                                )}
                            </div>
                        </>
                    )}
                </Droppable>
            </div>
        );
    });

    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const {
            draggableId: strCodeValue,
            destination: {droppableId: destinationId},
            source: {droppableId: sourceId},
        } = result;

        if (sourceId === destinationId) {
            return;
        }

        // 拖回去
        if ("droppable" === destinationId) {
            const option = options.find((o) => o.codeValue === +strCodeValue);
            leftOptions.push(option);
            setLeftOptions(leftOptions);
            const newAnswerObj = cloneDeep(answerObj);
            delete newAnswerObj[sourceId];
            setAnswerObj(newAnswerObj);
        } else if (!!answerObj[destinationId] && !!answerObj[sourceId]) {
            // 交换
            const destinationOpt = answerObj[destinationId];
            const sourceOpt = answerObj[sourceId];
            const newAnswerObj = cloneDeep(answerObj);
            newAnswerObj[destinationId] = sourceOpt;
            newAnswerObj[sourceId] = destinationOpt;
            setAnswerObj(newAnswerObj);
        } else if (!!answerObj[sourceId]) {
            // 放到其他位置
            const sourceOpt = answerObj[sourceId];
            const newAnswerObj = cloneDeep(answerObj);
            newAnswerObj[destinationId] = sourceOpt;
            delete newAnswerObj[sourceId];
            setAnswerObj(newAnswerObj);
        } else {
            // 默认放置
            const option = leftOptions.find((o) => o.codeValue === +strCodeValue);
            const newLeft = leftOptions.filter((o) => o.codeValue !== +strCodeValue);
            const selectedOpt = answerObj[destinationId];
            if (selectedOpt) {
                // 如果之前选中，把选中的放回待选中的数组中
                newLeft.push(selectedOpt);
                delete answerObj[destinationId];
            }
            setLeftOptions(newLeft);
            setAnswerObj({...answerObj, [destinationId]: option});
        }
    };

    const handleCheckbox = (option, checked) => {
        if (childs.length === Object.keys(answerObj).length && checked) return;
        const getId = (o) => o.id;
        const questionIds = childs.map(getId);
        const optionId = option.id;
        if (checked) {
            const newOptions = leftOptions.filter((o) => o.id !== optionId);
            setLeftOptions(newOptions);
            if (isEmpty(answer)) {
                setAnswerObj({[questionIds[0]]: option});
            } else {
                const emptyQuestionId = questionIds.find((id) => !answerObj[id]);
                setAnswerObj({...answerObj, [emptyQuestionId]: option});
            }
        } else {
            leftOptions.push(option);
            setLeftOptions(leftOptions);
            for (const key in answerObj) {
                if (Object.hasOwnProperty.call(answerObj, key)) {
                    const newAnswerObj = cloneDeep(answerObj);
                    const option = newAnswerObj[key];
                    if (option.id === optionId) {
                        delete newAnswerObj[key];
                        setAnswerObj(newAnswerObj);
                    }
                }
            }
        }
    };

    return (
        <div>
            {document.domain === "localhost" && <ReactJson src={answer}/>}
            <DragDropContext onDragEnd={onDragEnd}>
                {fixedOne && (
                    <div
                        key={-1}
                        style={{
                            background: "#bbd7f9",
                            margin: 10,
                            padding: 1,
                            filter: 'grayscale(60%)'
                        }}
                    >
                        <Droppable droppableId={-1} isDropDisabled={true}>
                            {(provided, snapshot) => (
                                <>
                                    <div
                                        style={{margin: 2, marginLeft: 10}}
                                        dangerouslySetInnerHTML={{
                                            __html: fixedOne?.description,
                                        }}
                                    />
                                    <div
                                        ref={provided.innerRef}
                                        style={
                                            {
                                                ...getListStyle(snapshot.isDraggingOver)
                                                , cursor: "not-allowed"
                                            }
                                        }
                                    >
                                        {!!fixedOne?.selectedOption && (
                                            <Draggable
                                                key={fixedOne?.selectedOption?.id}
                                                draggableId={fixedOne?.selectedOption?.codeValue + ""}
                                                index={0}
                                                isDragDisabled={true}
                                            >
                                                {(provided, snapshot) => (
                                                    <>
                                                        <div
                                                            className="draggable"
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={getItemStyle(
                                                                    snapshot.isDragging,
                                                                    provided.draggableProps.style,
                                                                true
                                                                )}
                                                        >
                                                            <Checkbox
                                                                style={{marginRight: 10, verticalAlign: "middle"}}
                                                                checked={true}
                                                                disabled={true}
                                                            />
                                                            <div
                                                                dangerouslySetInnerHTML={{
                                                                    __html: fixedOne?.selectedOption?.description,
                                                                }}
                                                            />
                                                            <MenuOutlined
                                                                style={{
                                                                    transform: "scaleX(1.5)",
                                                                    color: "gray",
                                                                    marginLeft: "auto",
                                                                }}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                            </Draggable>
                                        )}
                                    </div>
                                </>
                            )}
                        </Droppable>
                    </div>
                )}
                {questions}
                <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}
                        >
                            {leftOptions
                                .filter(({disable}) => !disable)
                                .map((item, index) => (
                                    <Draggable
                                        key={item.id}
                                        draggableId={item.codeValue + ""}
                                        index={index}
                                        isDragDisabled={item?.fixed === 1}
                                    >
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                    , item?.fixed === 1
                                                )
                                                }
                                            >
                                                <Checkbox
                                                    disabled={item?.fixed === 1}
                                                    style={{marginRight: 10, verticalAlign: "middle"}}
                                                    onChange={({target: {checked}}) => {
                                                        handleCheckbox(item, checked);
                                                    }}
                                                />
                                                <div
                                                    dangerouslySetInnerHTML={{__html: item.description}}
                                                />
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </div>
    );
}
